import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { SearchResultItem } from '@xiag-search/sdk';
import { logError } from 'src/sagas/utils/logError';
import { SearchResult } from 'src/state/SearchResult';
import { searchResolverWeather } from 'src/sagas/resolvers/searchResolverWeather';
import { searchResolverHotel } from 'src/sagas/resolvers/searchResolverHotel';
import { searchResolverFewo } from 'src/sagas/resolvers/searchResolverFewo';
import { searchResolverEvent } from 'src/sagas/resolvers/searchResolverEvent';
import { searchResolverDefault } from 'src/sagas/resolvers/searchResolverDefault';
import { searchResolverShopping } from 'src/sagas/resolvers/searchResolverShopping';
import { searchResolverOffer } from 'src/sagas/resolvers/searchResolverOffer';

export function* searchResolver(searchItem: SearchResultItem): SagaIterator {
    try {
        for (const resolver of [
            searchResolverWeather,
            searchResolverHotel,
            searchResolverFewo,
            searchResolverEvent,
            searchResolverShopping,
            searchResolverOffer,
            searchResolverDefault,
        ]) {
            const result: SearchResult | null = yield call(resolver, searchItem);
            if (result) {
                return result;
            }
        }

        yield call(logError, 'Could not resolve search item', { searchItem });
        return null;
    } catch (error) {
        yield call(logError, 'Could not process search item', { error, searchItem });
        return null;
    }
}
